import React, { useCallback } from "react";
import { DraftAlbum, useMusicApi } from "../../api/useMusicApi";
import { useLoading } from "../../hooks/use-loading";
import { useAdvancedState } from "../../hooks/use-advanced-state";
import { EditDraftForm } from "./EditDraftForm";
import { toast } from "react-toastify";
import { Preloader } from "../../components/Preloader";
import { useContractors } from "../../contexts/ContractorsContext";
import { useGenres } from "../../hooks/use-genres";
import { useValidationErrors } from "../../hooks/use-validation-errors";
import { AxiosError } from "axios";
import { usePageHelper } from "../../hooks/use-page-helper";
import { prepareArtistsToRequest } from "../../services/ArtistService";

export const AlbumCreateDraftPage: React.FC = () => {
  const {
    t,
    routeParams: { id },
    navigate
  } = usePageHelper("create_release");

  const { loadings, startLoading, stopLoading } = useLoading({
    album: false
  });

  const api = useMusicApi();
  const [album, setAlbum, updateAlbum] = useAdvancedState<DraftAlbum>({});
  const { genres } = useGenres();
  const { validationErrors, setValidationErrors } = useValidationErrors(album);
  const { contractors } = useContractors();

  const handleCreateDraft = useCallback(async () => {
    try {
      startLoading("album");
      delete album["trackrelease_set"];
      console.log(album);
      const res = await api.postCreateAlbumDraft({
        ...(album ?? {}),
        content_type: album?.content_type ?? "audio",
        code_icpn: album?.code_icpn ?? "",
        code_grid: album?.code_grid ?? "",
        genres: album?.genres ?? [],
        country_meta: {
          ...(album.country_meta ?? {}),
          subtitle: album?.country_meta?.subtitle ?? { ALL: null, RU: null },
          title: album?.country_meta?.title ?? { ALL: null, RU: null },
          artists: prepareArtistsToRequest(album?.country_meta ?? null)
        }
      } as any);
      setAlbum(res);
      toast.success(`${t("changes_save")}`);
      // @ts-ignore
      navigate(`/music/drafts/${res.id}`);
    } catch (e) {
      // @ts-ignore
      setValidationErrors(
        ((e as AxiosError).response?.data as any)?.errors ?? [],
        album as any
      );
      toast.error(`${t("changes_not_save")}`);
    } finally {
      stopLoading("album");
    }
  }, [id, album]);

  return (
    <div className={"flex-col w-full"}>
      {loadings.album && <Preloader className={"my-10"} size={"5x"} />}
      {!loadings.album && (
        <>
          <EditDraftForm
            isDraft={true}
            title={t("create_release")}
            entity={album}
            genres={genres}
            validationErrors={validationErrors}
            contractors={contractors}
            onChange={updateAlbum}
            onFileSelect={api.postUploadFile}
            onSaveAlbum={handleCreateDraft}
          />
        </>
      )}
    </div>
  );
};
